import { styled } from '@mui/material'

import { UserAvatar } from '@collaborate-health/uikit'

export const AnswererUserAvatar = styled(UserAvatar)({
  width: 19,
  height: 19,
  fontSize: 10,
})

